import types from 'constants/actionTypes';
import { combineReducers } from 'redux';

const initialState = {
  announcements: false,
  cart: false,
  cartSubmission: false,
  dashboard: false,
  modelCompetition: false,
  modelTemplates: false,
  modelTemplatesWorkingState: false,
  seriesAllocation: false,
  templateDetailImages: false,
  workingStateSubmission: false,
};

const announcements = (state, { type }) => {
  if (typeof state === 'undefined') {
    return initialState.announcements;
  }

  switch (type) {
    case types.GET_ANNOUNCEMENTS_REQUEST:
      return true;
    case types.GET_ANNOUNCEMENTS_REQUEST_SUCCESS:
    case types.GET_ANNOUNCEMENTS_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const cart = (state, { type }) => {
  if (typeof state === 'undefined') {
    return initialState.cart;
  }

  switch (type) {
    case types.GET_CART_REQUEST:
    case types.GET_ADDITIONAL_CART_REQUEST:
      return true;
    case types.GET_CART_REQUEST_SUCCESS:
    case types.GET_CART_REQUEST_FAILURE:
    case types.GET_ADDITIONAL_CART_REQUEST_SUCCESS:
    case types.GET_ADDITIONAL_CART_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const cartSubmission = (state, { type }) => {
  if (typeof state === 'undefined') {
    return initialState.cartSubmission;
  }

  switch (type) {
    case types.SUBMIT_CART_TEMPLATES_REQUEST:
      return true;
    case types.SUBMIT_CART_TEMPLATES_REQUEST_SUCCESS:
    case types.SUBMIT_CART_TEMPLATES_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const dashboard = (state, { type }) => {
  if (typeof state === 'undefined') {
    return initialState.dashboard;
  }

  switch (type) {
    case types.GET_DASHBOARD_REQUEST:
      return true;
    case types.GET_DASHBOARD_REQUEST_SUCCESS:
    case types.GET_DASHBOARD_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const modelCompetition = (state, { type }) => {
  if (typeof state === 'undefined') return initialState.modelCompetition;

  switch (type) {
    case types.GET_MODEL_COMPETITION_REQUEST:
      return true;
    case types.GET_MODEL_COMPETITION_REQUEST_SUCCESS:
    case types.GET_MODEL_COMPETITION_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const modelTemplates = (state, { type }) => {
  if (typeof state === 'undefined') {
    return initialState.modelTemplates;
  }

  switch (type) {
    case types.GET_MODEL_TEMPLATES_SPECS_REQUEST:
      return true;
    case types.GET_MODEL_TEMPLATES_SPECS_REQUEST_SUCCESS:
    case types.GET_MODEL_TEMPLATES_SPECS_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const templateDetailImages = (state, { type }) => {
  if (typeof state === 'undefined') {
    return initialState.templateDetailImages;
  }

  switch (type) {
    case types.GET_TEMPLATE_DETAIL_IMAGES_REQUEST:
      return true;
    case types.GET_TEMPLATE_DETAIL_IMAGES_REQUEST_SUCCESS:
    case types.GET_TEMPLATE_DETAIL_IMAGES_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const modelTemplatesWorkingState = (state, { type }) => {
  if (typeof state === 'undefined')
    return initialState.modelTemplatesWorkingState;

  switch (type) {
    case types.GET_MODEL_TEMPLATES_WORKING_STATE_REQUEST:
      return true;
    case types.GET_MODEL_TEMPLATES_WORKING_STATE_REQUEST_SUCCESS:
    case types.GET_MODEL_TEMPLATES_WORKING_STATE_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const seriesAllocation = (state, { type }) => {
  if (typeof state === 'undefined') {
    return initialState.seriesAllocation;
  }

  switch (type) {
    case types.GET_DEALERSHIP_ALLOCATION_REQUEST:
      return true;
    case types.GET_DEALERSHIP_ALLOCATION_REQUEST_SUCCESS:
    case types.GET_DEALERSHIP_ALLOCATION_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const workingStateSubmission = (state, { type }) => {
  if (typeof state === 'undefined') {
    return initialState.workingStateSubmission;
  }

  switch (type) {
    case types.ADD_TEMPLATES_TO_CART_REQUEST:
      return true;
    case types.ADD_TEMPLATES_TO_CART_REQUEST_SUCCESS:
    case types.ADD_TEMPLATES_TO_CART_REQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  announcements,
  cart,
  cartSubmission,
  dashboard,
  modelCompetition,
  modelTemplates,
  modelTemplatesWorkingState,
  seriesAllocation,
  templateDetailImages,
  workingStateSubmission,
});
